<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     消息中心-公告列表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fnc-notice-list">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>
    <el-card v-loading="listLoading" shadow="never" class="notice-container mb-md" :body-style="{ padding: '30px' }">
      <el-table
        ref="noticeListTable"
        :data="list"
        :show-header="false"
        class="padding-large"
        style="width: 100%"
        @row-click="onTableRowClick">
        <el-table-column label="标题">
          <template slot-scope="scope">
            {{ scope.row.title }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" align="right">
          <template slot-scope="scope">
            <span class="text-muted">{{ scope.row.createtime | formatTime }}</span>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="listQuery.pindex" :psize.sync="listQuery.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getNoticeListApi } from '@/api/fnc/fncNoticeApi'
export default {
  name: 'FncNotice',
  components: {
  },
  data() {
    return {
      listLoading: false,
      listQuery: {
        pindex: 1,
        psize: 10
      },
      total: 0,
      list: []
    }
  },
  created() {
    const keepAlivePath = [
      '/fnc/notice/detail'
    ]
    this.listQuery = this.$utils.initListQuery(this.listQuery, keepAlivePath)
    this.fetchData()
  },
  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.listQuery)
    next()
  },
  methods: {
    fetchData(page) {
      if (page) this.listQuery.pindex = page
      this.listLoading = true
      getNoticeListApi(this.listQuery).then(res => {
        this.listLoading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    },
    onTableRowClick(row) {
      this.$router.push('/fnc/notice/detail?id=' + row.id)
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.fnc-notice-list {
  width: 1200px;
  margin: 0 auto;
  .notice-container {
    .el-table .el-table__row {
      cursor: pointer;
    }
    .el-table .cell {
      line-height: 27px;
    }
  }
}
</style>
